<script>
export default {
  props: {
    staff: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleDelete({ id, name }) {
      this.$emit("delete", { id, name });
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col gap-4 p-4 shadow-md rounded-lg bg-white dark:bg-slate-800 mb-4 transition-all duration-300 hover:shadow-lg"
  >
    <div class="flex justify-between items-center">
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
        {{ staff.name }}
      </h2>

      <woot-button
        variant="clear"
        size="tiny"
        color-scheme="alert"
        icon="delete"
        @click="handleDelete({ id: staff.id, name: staff.name })"
      >
        Remove
      </woot-button>
    </div>
  </div>
</template>
